import { useState } from "react";
import { INR } from "@/lib/format";
import { Search } from "lucide-react";

export default function CustomerListPanel({ customers, value, onChange, testid = "stmt-customer" }) {
  const [q, setQ] = useState("");
  const ql = q.trim().toLowerCase();
  const list = [...customers]
    .sort((a, b) => a.name.localeCompare(b.name))
    .filter(c => !ql || c.name.toLowerCase().includes(ql) || String(c.phone||"").includes(ql));
  return (
    <div className="bg-white border border-slate-200 rounded-md overflow-hidden flex flex-col" data-testid={testid}>
      <div className="p-2 border-b border-slate-200">
        <div className="flex items-center h-9 border border-slate-300 rounded bg-white focus-within:border-blue-600">
          <Search size={14} className="ml-2 text-slate-400 shrink-0"/>
          <input data-testid={`${testid}-input`} value={q} onChange={(e)=>setQ(e.target.value)} placeholder="Search customer…" className="flex-1 h-full px-2 text-sm outline-none bg-transparent"/>
        </div>
      </div>
      <div className="px-3 py-1.5 text-[10px] uppercase tracking-wider font-semibold text-slate-500 bg-slate-50 border-b border-slate-200 flex justify-between"><span>Customer (A–Z)</span><span>{list.length}</span></div>
      <div className="overflow-y-auto max-h-[40vh] lg:max-h-[70vh]" data-testid={`${testid}-list`}>
        {list.map(c => (
          <button key={c.id} type="button" data-testid={`${testid}-option-${c.id}`} onClick={()=>onChange(c.id)}
            className={`w-full text-left px-3 py-2 border-b border-slate-100 hover:bg-slate-50 flex items-center justify-between gap-2 ${c.id===value ? "bg-blue-50 border-l-2 border-l-blue-600" : ""}`}>
            <div className="min-w-0"><div className="text-sm font-medium truncate">{c.name}</div>{c.phone && <div className="text-[11px] mono text-slate-500">{c.phone}</div>}</div>
            {"balance" in c && <div className={`text-xs mono shrink-0 ${c.balance>0?"text-rose-800":c.balance<0?"text-emerald-800":"text-slate-500"}`}>{INR(c.balance)}</div>}
          </button>
        ))}
        {!list.length && <div className="px-3 py-4 text-sm text-slate-400">No customers match “{q}”</div>}
      </div>
    </div>
  );
}
